import * as React from 'react';

import { NewbuildingFlatSaleHeaderFieldContainer } from './newBuildingFlatSale';
import { FlatSaleHeaderFieldContainer } from './flatSale';
import { ECategory } from '../../../../types/category';
import { EmptyField } from '../../../../components/Field/common';
import { useOfferContext } from '../../../../utils/offerContext';

export interface IHeaderFieldContainerProps {
  dragging?: boolean;
  sticky?: boolean;
}

const HeaderFieldContainer = ({ sticky, dragging }: IHeaderFieldContainerProps): React.JSX.Element => {
  const { category } = useOfferContext();

  switch (category) {
    case ECategory.NewBuildingFlatSale:
      return <NewbuildingFlatSaleHeaderFieldContainer sticky={sticky} dragging={dragging} />;
    case ECategory.FlatSale:
      return <FlatSaleHeaderFieldContainer sticky={sticky} dragging={dragging} />;
    default:
      return <EmptyField />;
  }
};

const MemoizedHeaderFieldContainer = React.memo(HeaderFieldContainer);

export { MemoizedHeaderFieldContainer as HeaderFieldContainer };
